import React from 'react';
import { Shield, FileText, AlertTriangle, Scale } from 'lucide-react';

export default function DMCAPage() {
  return (
    <div className="min-h-screen bg-texture py-12 px-4" data-testid="dmca-page">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-black mb-8 neon-cyan flex items-center gap-3" data-testid="dmca-title">
          <Shield size={32} /> Legal & Compliance
        </h1>

        <div className="space-y-6">
          {/* DMCA */}
          <div className="ch-card p-6" data-testid="dmca-section">
            <h2 className="text-lg font-bold flex items-center gap-2 mb-4">
              <FileText size={18} className="text-[--ch-cyan]" /> DMCA Notice & Takedown Policy
            </h2>
            <div className="space-y-3 text-sm text-[--ch-text-secondary]">
              <p>Creator Hub respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998 (DMCA), we will respond expeditiously to claims of copyright infringement.</p>
              <p><strong className="text-white">Filing a DMCA Notice:</strong> If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement, please provide our designated agent with the following information:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>A physical or electronic signature of the copyright owner</li>
                <li>Identification of the copyrighted work claimed to have been infringed</li>
                <li>Identification of the material that is claimed to be infringing</li>
                <li>Your address, telephone number, and email address</li>
                <li>A statement of good faith belief that the use is not authorized</li>
                <li>A statement under penalty of perjury that the information is accurate</li>
              </ul>
              <p><strong className="text-white">Counter-Notification:</strong> If you believe that your content was removed or disabled by mistake or misidentification, you may file a counter-notification containing a statement under penalty of perjury.</p>
            </div>
          </div>

          {/* Terms of Service */}
          <div className="ch-card p-6" data-testid="terms-section">
            <h2 className="text-lg font-bold flex items-center gap-2 mb-4">
              <Scale size={18} className="text-[--ch-magenta]" /> Terms of Service
            </h2>
            <div className="space-y-3 text-sm text-[--ch-text-secondary]">
              <p><strong className="text-white">Eligibility:</strong> You must be at least 18 years old to use this platform. By accessing Creator Hub, you confirm that you are of legal age in your jurisdiction.</p>
              <p><strong className="text-white">Content Standards:</strong> All content posted must comply with applicable laws. Creators are responsible for ensuring they have the rights to distribute any content they upload.</p>
              <p><strong className="text-white">Subscriptions & Payments:</strong> Subscriptions are billed according to the selected plan. Refunds are handled on a case-by-case basis. All transactions are processed securely through Stripe.</p>
              <p><strong className="text-white">Account Termination:</strong> We reserve the right to suspend or terminate accounts that violate these terms without prior notice.</p>
              <p><strong className="text-white">Content Removal:</strong> We reserve the right to remove any content that violates our community guidelines or applicable laws.</p>
            </div>
          </div>

          {/* Privacy Policy */}
          <div className="ch-card p-6" data-testid="privacy-section">
            <h2 className="text-lg font-bold flex items-center gap-2 mb-4">
              <AlertTriangle size={18} className="text-[--ch-purple]" /> Privacy Policy
            </h2>
            <div className="space-y-3 text-sm text-[--ch-text-secondary]">
              <p><strong className="text-white">Data Collection:</strong> We collect information necessary to provide our services, including email addresses, payment information (processed by Stripe), and usage data.</p>
              <p><strong className="text-white">Data Usage:</strong> Your personal data is used solely for providing and improving our services. We do not sell your personal information to third parties.</p>
              <p><strong className="text-white">Cookies:</strong> We use essential cookies for authentication and session management. Analytics cookies may be used to improve user experience.</p>
              <p><strong className="text-white">Data Retention:</strong> Account data is retained as long as your account is active. You may request deletion of your account and associated data at any time.</p>
              <p><strong className="text-white">Security:</strong> We implement industry-standard security measures to protect your data, including encryption in transit and at rest.</p>
            </div>
          </div>

          {/* 2257 Compliance */}
          <div className="ch-card p-6" data-testid="compliance-section">
            <h2 className="text-lg font-bold flex items-center gap-2 mb-4">
              <Shield size={18} className="text-[--ch-success]" /> 18 U.S.C. 2257 Compliance
            </h2>
            <div className="space-y-3 text-sm text-[--ch-text-secondary]">
              <p>All content creators on this platform are required to verify their age and identity. Records required pursuant to 18 U.S.C. 2257 and associated regulations are maintained by the custodian of records.</p>
              <p>All models, actors, and other persons depicted in visual content were 18 years of age or older at the time of creation.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
